// @ts-check
const pathToRegexp = require('path-to-regexp');

/**
 * --- PAGES ---
 */
const pages = {
  blogPost: '/blog-post',
  blogHomepage: '/blog-homepage',
  blogCategory: '/blog-homepage',
  glossaryHomepage: '/glossary-homepage',
  glossaryTerm: '/glossary-term',
  getOffer: '/get-offer',
  survey: '/survey',
  login: '/login',
  atlas: '/atlas',
  atlasOld: '/atlas-old',
  atlasTransferCuzkDetail: '/atlas-transfer-cuzk-detail',
  atlasBuildingCuzkDetail: '/atlas-building-cuzk-detail',
  atlasParcelCuzkDetail: '/atlas-parcel-cuzk-detail',
  atlasUnitCuzkDetail: '/atlas-unit-cuzk-detail',
  page: '/page',
  estimateResult: '/estimate-result',
  estimateSurvey: '/estimate-survey',
  phoneVerification: '/phone-verification',
  estimateEmailSent: '/estimate-email-sent',
  subscribeEstimateEmailSent: '/subscribe-estimate-email-sent',
  brokerHandover: '/broker-handover',
  estimateSubscribedContact: '/estimate-subscribed-contact',
  surveyToSell: '/survey-to-sell',
  estateDashboard: '/estate-dashboard',
  estimateSurveyV3: '/estimate-survey',
  buyersSurvey: '/buyers-survey',
  adEstate: '/ad-estate',
  atlasAdCatalog: '/atlas-ad-catalog',
  atlasAdCatalogDetail: '/atlas-ad-catalog',
  estimateLandingPage: '/estimate-landing-page',
  mortgageSurvey: '/mortgage-survey',
};

/**
 * @type {import('./routes').CreateRoute}
 */
const createRoute = (path, page) => [path, page, pathToRegexp.compile(path)];

/**
 * --- ROUTES ---
 * @type {import('./routes').Routes}
 **/
const routes = {
  estimateLandingPage: createRoute('/odhad-ceny', pages.estimateLandingPage),

  estateDashboard: createRoute('/nemovitost/:flag?', pages.estateDashboard),

  adEstate: createRoute('/detail-nabidky/:detailId', pages.adEstate),

  phoneVerification: createRoute(
    '/overeni-telefonu/:leadId',
    pages.phoneVerification,
  ),
  // BLOG HOMEPAGE
  blogHomepage: createRoute('/blog', pages.blogHomepage),
  blogCategory: createRoute('/blog/kategorie/:category', pages.blogHomepage),
  // BLOG
  blogPost: createRoute('/blog/:slug', pages.blogPost),
  //GLOSSARY HOMEPAGE
  glossaryHomepage: createRoute('/slovnicek', pages.glossaryHomepage),
  //GLOSSARY
  glossaryTerm: createRoute('/slovnicek/:slug', pages.glossaryTerm),
  // SPLIT CONTACT PAGE
  estimateSubscribedContact: createRoute(
    '/kontakt-presny-odhad/:leadId/:estimateId',
    pages.estimateSubscribedContact,
  ),
  // SURVEYS
  surveyGetOffer: createRoute('/chci-nabidku/:step?', pages.survey),
  estimateResult: createRoute(
    '/chci-odhad/dekujeme/:pid?',
    pages.estimateResult,
  ),
  brokerHandover: createRoute(
    '/spojeni-s-maklerem/:step?',
    pages.brokerHandover,
  ),
  estimateSurvey: createRoute('/chci-odhad/:step?', pages.estimateSurvey),
  // ATLAS
  atlasTransferCuzkDetail: createRoute(
    '/atlas-cen/vlastnici/:transferId',
    pages.atlasTransferCuzkDetail,
  ),
  atlasBuildingCuzkDetail: createRoute(
    '/atlas-cen/budova/:buildingId',
    pages.atlasBuildingCuzkDetail,
  ),
  atlasParcelCuzkDetail: createRoute(
    '/atlas-cen/parcela/:parcelId',
    pages.atlasParcelCuzkDetail,
  ),
  atlasUnitCuzkDetail: createRoute(
    '/atlas-cen/jednotka/:unitId',
    pages.atlasUnitCuzkDetail,
  ),
  atlas: createRoute('/prodane/:slug?', pages.atlas),
  atlasOld: createRoute('/atlas-cen/:slug?', pages.atlasOld),

  atlasAdCatalog: createRoute('/na-prodej', pages.atlasAdCatalog),
  atlasAdCatalogDetail: createRoute(
    '/na-prodej/detail-nabidky/:adEstate',
    pages.atlasAdCatalog,
  ),

  // LOGIN
  login: createRoute('/prihlasit', pages.login),

  estimateEmailSent: createRoute(
    '/odhad-odeslano/:leadId',
    pages.estimateEmailSent,
  ),
  subscribeEstimateEmailSent: createRoute(
    '/sub-odhad-odeslano/:leadId',
    pages.subscribeEstimateEmailSent,
  ),
  surveyToSell: createRoute('/chci-prodat/:step?', pages.surveyToSell),
  estimateSurveyV3: createRoute(
    '/chci-odhad-v3/:step?',
    pages.estimateSurveyV3,
  ),
  buyersSurvey: createRoute('/chci-koupit/:step?', pages.buyersSurvey),
  mortgageSurvey: createRoute('/chci-hypoteku/:step?', pages.mortgageSurvey),

  // Dynamic pages (from CMS) last
  page: createRoute('/:path([^/.]+)', pages.page),
  // Homepage as dynamic page
  homepage: createRoute('/', pages.page),
};

const rewrites = Object.entries(routes).map(([, [source, destination]]) => ({
  source,
  destination,
}));

module.exports = { routes, rewrites };
